<template>
    <div class="container"> 
        <div class="logos">
            <img src="@/assets/escudo.webp" alt="">
        </div>
        <div class="logout">
            <LogoutComponent></LogoutComponent>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';
.container{
    display: flex;
    justify-items: center;
    align-items: center;
   
    justify-content: space-between;
   
}
 .logos{
    width: 8%;
 }
 .logos img{
    width: 70%;
 }
 .logout{
    width: 10%;
 }
</style>
<script>
import LogoutComponent from './logoutComponent.vue';

    export default{
        components:{
            LogoutComponent
        }
    }
</script>

